import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What happens after I submit the form?',
  answer: 'A Storm coach will reach out to confirm the best starting class for you and answer any questions about trial pricing and current enrollment options.'
}, {
  question: 'Do I need any experience to start?',
  answer: 'No. The vast majority of Storm students start with zero martial arts experience — kids, adults and families.'
}, {
  question: 'What ages do you teach?',
  answer: 'Storm teaches ages 3 and up. Mini Troopers is for ages 3–5, Kids Taekwondo for ages 6+, and adult classes are open to teens through senior citizens.'
}, {
  question: 'What is the current trial or signup offer?',
  answer: 'Trial and enrollment options change. Contact Storm Taekwondo at 517-220-0621 or submit the form on this page for current pricing and what is available right now.'
}, {
  question: 'Where is Storm located?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335 — easy to reach from Novi, Commerce, Walled Lake, Wixom, Livonia, Northville and Waterford.'
}];
export function Page31FAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2749" />;
}